import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ROOTROUTES } from "./assembly";
import { AuthGuard } from "./shared";

@NgModule({
    imports: [RouterModule.forRoot(ROOTROUTES)],
    exports: [RouterModule],
    providers:[AuthGuard]
})
export class AppRoutingModule { }